import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import './App.css';
import Home from './pages/Home';
import Services from './pages/Services';
import Booking from './pages/Booking';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import DownloadApp from './pages/DownloadApp';
import AdminLogin from './pages/admin/AdminLogin';
import AcceptInvite from './pages/admin/AcceptInvite';
import ManagerDashboard from './pages/admin/ManagerDashboard';
import WebmasterDashboard from './pages/admin/WebmasterDashboard';
import RequireRole from './admin/RequireRole';

// Public navbar everywhere except the admin panels.
function Chrome() {
  const location = useLocation();
  if (location.pathname.startsWith('/portal')) return null;
  return <Navbar />;
}

function App() {
  return (
    <Router>
      <Chrome />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/app" element={<DownloadApp />} />

        {/* Admin panels */}
        <Route path="/portal/login" element={<AdminLogin />} />
        <Route path="/portal/accept" element={<AcceptInvite />} />
        <Route path="/portal/manager" element={<RequireRole role="manager"><ManagerDashboard /></RequireRole>} />
        <Route path="/portal/webmaster" element={<RequireRole role="webmaster"><WebmasterDashboard /></RequireRole>} />
        <Route path="/portal" element={<AdminLogin />} />
      </Routes>
    </Router>
  );
}

export default App;
